var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlsPreviewCheckmark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 69,
    viewBox: "0 0 96 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 13,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#4EE5B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4828 33.1959C56.9969 32.735 57.04 31.9447 56.5791 31.4307C56.1183 30.9167 55.328 30.8736 54.814 31.3344L43.1117 41.8261L37.4017 36.1161C36.9136 35.628 36.1221 35.628 35.6339 36.1161C35.1458 36.6043 35.1458 37.3957 35.6339 37.8839L41.9272 44.1771C41.9708 44.2207 42.0168 44.2604 42.0648 44.2962C42.0866 44.3252 42.1098 44.3536 42.1345 44.3811C42.5953 44.8951 43.3856 44.9382 43.8996 44.4774L56.4828 33.1959Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 0L11.4308 6.56918L18 9L11.4308 11.4308L9 18L6.56918 11.4308L0 9L6.56918 6.56918L9 0Z",
    fill: "#4EE5B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89 55L90.8906 60.1094L96 62L90.8906 63.8906L89 69L87.1094 63.8906L82 62L87.1094 60.1094L89 55Z",
    fill: "#4EE5B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 41L8.35045 44.6495L12 46L8.35045 47.3505L7 51L5.64955 47.3505L2 46L5.64955 44.6495L7 41Z",
    fill: "#4EE5B1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80 13L81.3505 16.6495L85 18L81.3505 19.3505L80 23L78.6495 19.3505L75 18L78.6495 16.6495L80 13Z",
    fill: "#4EE5B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlsPreviewCheckmark);
export default __webpack_public_path__ + "static/media/BLSPreview-Checkmark.e3747f154c34a12acaa6eb1d077eb9d2.svg";
export { ForwardRef as ReactComponent };